import React from "react";
import { useLocation, Link } from "react-router-dom";

// Helper to format a segment: replace - with space, capitalize each word
const formatSegment = (segment) =>
  segment
    .replace(/-/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

const GenericBreadcrumbs = () => {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);
  let path = "";
  return (
    <nav className="flex items-center space-x-2 text-base font-medium my-3">
      {segments.map((segment, idx) => {
        path += `/${segment}`;
        const label = formatSegment(segment);
        const isLast = idx === segments.length - 1;
        const isFirst = idx === 0;
        return (
          <span key={path} className="flex items-center">
            {!isLast ? (
              <>
                {isFirst ? (
                  <span className="text-neutral-700">{label}</span>
                ) : (
                  <Link to={path} className="text-neutral-700 hover:underline">{label}</Link>
                )}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-1">
                  <path d="M16 3.00195L7 12.002L16 21.002" stroke="#6E6E6E" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </>
            ) : (
              <span className="text-slate-700 capitalize">{label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default GenericBreadcrumbs;
